import React from 'react';

import { Checkbox } from '../../../../common/checkbox/Checkbox';
import { ToolTip } from '../../../../common/tool-tip/ToolTip';

import './ClientAdditionalInfo.css';

export const ClientAdditionalInfo = ({
  context,
  toolTipsEnabled,
  showToaster,
  setSpinnerText,
  clientAdditionalInformation,
  handleClientAdditionalInformationChange,
  fieldsDisabled,
}) => {
  const handleHomeVisitCheckboxChange = (value) => {
    handleClientAdditionalInformationChange('homeVisitAllowed', value);
  };

  return (
    <div className="tab-container">
      <div className="additional-info-checkbox-container">
        <div className="input-container" style={{ marginTop: '15px' }}>
          <label className={'additional-info-checkboxes-label-med'}>
            Can we perform a home visit when your contact detail is not functional?
          </label>
          <Checkbox
            label={'Yes'}
            fillStyle={true}
            checked={clientAdditionalInformation.homeVisitAllowed}
            onChange={() => handleHomeVisitCheckboxChange(true)}
            disabled={fieldsDisabled}
            color={'#000000'}
          />
          <Checkbox
            label={'No'}
            fillStyle={true}
            checked={!clientAdditionalInformation.homeVisitAllowed}
            onChange={() => handleHomeVisitCheckboxChange(false)}
            disabled={fieldsDisabled}
            color={'#000000'}
          />
        </div>

        <div className="additional-info-section">
          <div className="input-container">
            <label className={'input-area-label-long'}>Additional Tracing Information:</label>
            <textarea
              className="input-area"
              spellCheck={true}
              type="text"
              value={clientAdditionalInformation.additionalInfo}
              disabled={fieldsDisabled}
              onChange={({ target }) => {
                handleClientAdditionalInformationChange('additionalInfo', target.value);
              }}
            />
            {toolTipsEnabled && (
              <ToolTip
                tooltipExternalReference={'clientAdditionalTracingInfo123'}
                context={context}
                setSpinnerText={setSpinnerText}
                showToaster={showToaster}
                fieldName={'Additional Tracing Information:'}
              />
            )}
          </div>
          <h5 className={'locator-information-reminder'}>
            Please make sure that the client signs the latest version of the physical locator sheet.
          </h5>
        </div>
      </div>
    </div>
  );
};
